import StartupCalculator from 'StartupCalculator';

window.StartupCalculator = StartupCalculator;



// WEBPACK FOOTER //
// ./src-assets/js/startup-calculator.js